document.addEventListener('DOMContentLoaded', () => {
  const planners = document.querySelectorAll('.kbp');

  planners.forEach((planner) => {
    const sectionId = planner.dataset.sectionId;
    const dataEl = document.getElementById(`kbp-data-${sectionId}`);
    const settings = dataEl ? JSON.parse(dataEl.textContent) : {};
    const moneyFormat = settings.moneyFormat || '${{amount}}';

    const tabs = planner.querySelectorAll('[data-kbp-tab]');
    const panels = planner.querySelectorAll('[data-kbp-panel]');
    const subfilters = planner.querySelectorAll('[data-kbp-filter]');
    const itemsWrap = planner.querySelector('[data-kbp-items]');
    const accessoriesWrap = planner.querySelector('[data-kbp-items-accessories]');

    const visualBaseWrap = planner.querySelector('[data-kbp-visual-base]');
    const visualWallWrap = planner.querySelector('[data-kbp-visual-wall]');
    const visualTallWrap = planner.querySelector('[data-kbp-visual-tall]');

    const totalItemsEl = planner.querySelector('[data-kbp-total-items]');
    const totalBaseWidthEl = planner.querySelector('[data-kbp-total-base-width]');
    const totalWallWidthEl = planner.querySelector('[data-kbp-total-wall-width]');
    const totalTallWidthEl = planner.querySelector('[data-kbp-total-tall-width]');
    const totalPriceEl = planner.querySelector('[data-kbp-total-price]');

    const addAllBtn = planner.querySelector('[data-kbp-add-all]');
    const clearBtn = planner.querySelector('[data-kbp-clear]');
    const globalDoorSelect = planner.querySelector('[data-kbp-global-door]');
    const globalBodySelect = planner.querySelector('[data-kbp-global-body]');
    const selectedFinishEl = planner.querySelector('[data-kbp-selected-finish]');
    const finishNoteEl = planner.querySelector('[data-kbp-finish-note]');

    const baseWidthInput = planner.querySelector('[data-kbp-base-width]');
    const wallWidthInput = planner.querySelector('[data-kbp-wall-width]');
    const tallWidthInput = planner.querySelector('[data-kbp-tall-width]');

    const fitBaseEl = planner.querySelector('[data-kbp-fit-base]');
    const fitWallEl = planner.querySelector('[data-kbp-fit-wall]');
    const fitTallEl = planner.querySelector('[data-kbp-fit-tall]');

    let planItems = [];

    const formatMoney = (cents) => {
      const amount = (Number(cents || 0) / 100).toFixed(2);
      return moneyFormat.replace('{{amount}}', amount).replace('{{ amount }}', amount);
    };

    const getSelectedDoor = () => globalDoorSelect?.value || '';
    const getSelectedBody = () => globalBodySelect?.value || '';
    const hasGlobalFinish = () => getSelectedDoor() !== '' && getSelectedBody() !== '';

    const getRunTarget = (runType) => {
      if (runType === 'base') return parseFloat(baseWidthInput?.value || 0) || 0;
      if (runType === 'wall') return parseFloat(wallWidthInput?.value || 0) || 0;
      if (runType === 'tall') return parseFloat(tallWidthInput?.value || 0) || 0;
      return 0;
    };

    const getFitElement = (runType) => {
      if (runType === 'base') return fitBaseEl;
      if (runType === 'wall') return fitWallEl;
      if (runType === 'tall') return fitTallEl;
      return null;
    };

    const getVisualWrap = (runType) => {
      if (runType === 'base') return visualBaseWrap;
      if (runType === 'wall') return visualWallWrap;
      if (runType === 'tall') return visualTallWrap;
      return null;
    };

    const findVariant = (variants, option1, option2) => {
      return variants.find((variant) => {
        const match1 = String(variant.option1 || '') === String(option1 || '');
        const match2 = String(variant.option2 || '') === String(option2 || '');
        return match1 && match2;
      });
    };

    const updateSelectedFinishBox = () => {
      const door = getSelectedDoor() || '—';
      const body = getSelectedBody() || '—';

      if (selectedFinishEl) {
        selectedFinishEl.innerHTML = `Door: ${door}<br>Body: ${body}`;
      }

      if (finishNoteEl) {
        finishNoteEl.textContent = hasGlobalFinish()
          ? 'Now choose your cabinets. All cards use this finish combination.'
          : 'Select door color and body color first.';
      }
    };

    const updateCardsForGlobalFinish = () => {
      const door = getSelectedDoor();
      const body = getSelectedBody();

      planner.querySelectorAll('.kbp-card').forEach((card) => {
        const variantsJson = card.querySelector('.kbp-card__variants');
        const variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
        const priceEl = card.querySelector('[data-kbp-price]');
        const previewEl = card.querySelector('[data-kbp-finish-preview]');
        const addBtn = card.querySelector('[data-kbp-add]');

        if (!door || !body) {
          if (priceEl) priceEl.textContent = priceEl.dataset.baseText || priceEl.textContent;
          if (previewEl) previewEl.textContent = 'Select door and body colour';
          if (addBtn) {
            addBtn.disabled = true;
            addBtn.textContent = 'Select Finish First';
          }
          return;
        }

        const variant = findVariant(variants, door, body);

        if (!variant) {
          if (previewEl) previewEl.textContent = `${door} / ${body} not available`;
          if (addBtn) {
            addBtn.disabled = true;
            addBtn.textContent = 'Unavailable';
          }
          return;
        }

        if (priceEl) {
          if (!priceEl.dataset.baseText) priceEl.dataset.baseText = priceEl.textContent;
          priceEl.textContent = formatMoney(variant.price);
        }

        if (previewEl) {
          previewEl.textContent = `${door} / ${body}`;
        }

        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? 'Add to Plan' : 'Out of Stock';
        }
      });
    };

    const updateFitStatus = (runType, totalWidth) => {
      const fitEl = getFitElement(runType);
      if (!fitEl) return;

      const target = getRunTarget(runType);

      if (!target) {
        fitEl.textContent = 'Enter target width to check fit.';
        fitEl.className = 'kbp__fit-status';
        return;
      }

      const difference = +(target - totalWidth).toFixed(2);

      if (difference > 0) {
        fitEl.textContent = `Fits. ${difference}" remaining.`;
        fitEl.className = 'kbp__fit-status is-fit';
      } else if (difference === 0) {
        fitEl.textContent = 'Perfect fit.';
        fitEl.className = 'kbp__fit-status is-perfect';
      } else {
        fitEl.textContent = `Exceeds width by ${Math.abs(difference)}".`;
        fitEl.className = 'kbp__fit-status is-over';
      }
    };

    const buildGroupedItems = () => {
      const groupedMap = new Map();

      planItems.forEach((item) => {
        const key = `${item.variantId}`;
        if (!groupedMap.has(key)) {
          groupedMap.set(key, { ...item, quantity: 1 });
        } else {
          groupedMap.get(key).quantity += 1;
        }
      });

      return Array.from(groupedMap.values());
    };

    const renderVisualRun = (runType, groupedItems) => {
      const wrap = getVisualWrap(runType);
      if (!wrap) return;

      wrap.innerHTML = '';

      const runItems = groupedItems.filter((item) => item.runType === runType);

      if (!runItems.length) {
        wrap.innerHTML = '<p class="kbp__empty">No items added.</p>';
        return;
      }

      runItems.forEach((item) => {
        for (let i = 0; i < item.quantity; i += 1) {
          const visual = document.createElement('div');
          visual.className = 'kbp__visual-block';
          visual.style.width = `${Math.max(52, (parseFloat(item.width) || 0) * 2.1)}px`;
          visual.innerHTML = `
            <div class="kbp__visual-block-inner">
              <span class="kbp__visual-width">${item.width}"</span>
            </div>
          `;
          wrap.appendChild(visual);
        }
      });
    };

    const renderPlan = () => {
      itemsWrap.innerHTML = '';
      accessoriesWrap.innerHTML = '';

      const groupedItems = buildGroupedItems();

      renderVisualRun('base', groupedItems);
      renderVisualRun('wall', groupedItems);
      renderVisualRun('tall', groupedItems);

      if (!groupedItems.length) {
        itemsWrap.innerHTML = '<p class="kbp__empty">No cabinets added yet.</p>';
        accessoriesWrap.innerHTML = '<p class="kbp__empty">No accessories added yet.</p>';
        totalItemsEl.textContent = '0';
        totalBaseWidthEl.textContent = '0';
        totalWallWidthEl.textContent = '0';
        totalTallWidthEl.textContent = '0';
        totalPriceEl.textContent = formatMoney(0);
        addAllBtn.disabled = true;
        updateFitStatus('base', 0);
        updateFitStatus('wall', 0);
        updateFitStatus('tall', 0);
        return;
      }

      let totalItems = 0;
      let totalPrice = 0;
      let totalBaseWidth = 0;
      let totalWallWidth = 0;
      let totalTallWidth = 0;

      const accessoryItems = groupedItems.filter((item) => item.runType === 'trim');
      const cabinetItems = groupedItems.filter((item) => item.runType !== 'trim');

      if (!cabinetItems.length) {
        itemsWrap.innerHTML = '<p class="kbp__empty">No cabinets added yet.</p>';
      }

      if (!accessoryItems.length) {
        accessoriesWrap.innerHTML = '<p class="kbp__empty">No accessories added yet.</p>';
      }

      groupedItems.forEach((item) => {
        const lineWidth = (parseFloat(item.width) || 0) * item.quantity;
        const linePrice = (Number(item.price) || 0) * item.quantity;

        totalItems += item.quantity;
        totalPrice += linePrice;

        if (item.runType === 'base') totalBaseWidth += lineWidth;
        if (item.runType === 'wall') totalWallWidth += lineWidth;
        if (item.runType === 'tall') totalTallWidth += lineWidth;

        const itemEl = document.createElement('div');
        itemEl.className = 'kbp-item';
        itemEl.innerHTML = `
          <div class="kbp-item__top">
            <div>
              <div class="kbp-item__title">${item.title}</div>
              <div class="kbp-item__meta">
                Door Color: ${item.doorColor} · Body Color: ${item.bodyColor}
              </div>
              <div class="kbp-item__meta">
                Width: ${item.width}" · Qty: ${item.quantity} · ${formatMoney(linePrice)}
              </div>
            </div>
            <button type="button" class="kbp-item__remove" data-remove-all="${item.variantId}">Remove</button>
          </div>

          <div class="kbp-item__qty">
            <button type="button" class="kbp-item__qty-btn" data-qty-action="minus" data-variant-id="${item.variantId}">−</button>
            <span class="kbp-item__qty-value">${item.quantity}</span>
            <button type="button" class="kbp-item__qty-btn" data-qty-action="plus" data-variant-id="${item.variantId}">+</button>
          </div>
        `;

        if (item.runType === 'trim') {
          accessoriesWrap.appendChild(itemEl);
        } else {
          itemsWrap.appendChild(itemEl);
        }
      });

      totalItemsEl.textContent = String(totalItems);
      totalBaseWidthEl.textContent = String(totalBaseWidth);
      totalWallWidthEl.textContent = String(totalWallWidth);
      totalTallWidthEl.textContent = String(totalTallWidth);
      totalPriceEl.textContent = formatMoney(totalPrice);
      addAllBtn.disabled = false;

      updateFitStatus('base', totalBaseWidth);
      updateFitStatus('wall', totalWallWidth);
      updateFitStatus('tall', totalTallWidth);

      planner.querySelectorAll('[data-remove-all]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const variantId = String(btn.dataset.removeAll);
          planItems = planItems.filter((item) => String(item.variantId) !== variantId);
          renderPlan();
        });
      });

      planner.querySelectorAll('[data-qty-action]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const variantId = String(btn.dataset.variantId);
          const action = btn.dataset.qtyAction;

          if (action === 'plus') {
            const existing = planItems.find((item) => String(item.variantId) === variantId);
            if (existing) {
              planItems.push({ ...existing });
            }
          }

          if (action === 'minus') {
            const index = planItems.findIndex((item) => String(item.variantId) === variantId);
            if (index > -1) {
              planItems.splice(index, 1);
            }
          }

          renderPlan();
        });
      });
    };

    const setActiveTab = (target) => {
      tabs.forEach((t) => t.classList.remove('is-active'));
      panels.forEach((p) => p.classList.remove('is-active'));

      planner.querySelector(`[data-kbp-tab="${target}"]`)?.classList.add('is-active');
      planner.querySelector(`[data-kbp-panel="${target}"]`)?.classList.add('is-active');
    };

    const applyBaseFilter = (filterValue) => {
      const baseCards = planner.querySelectorAll('.kbp-card[data-parent-tab="base"]');

      baseCards.forEach((card) => {
        const cardFilter = card.dataset.plannerFilter || 'standard-base';

        if (filterValue === 'all' || filterValue === cardFilter) {
          card.classList.remove('is-hidden');
        } else {
          card.classList.add('is-hidden');
        }
      });

      subfilters.forEach((btn) => {
        btn.classList.toggle('is-active', btn.dataset.kbpFilter === filterValue);
      });
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.kbpTab;
        setActiveTab(target);
      });
    });

    subfilters.forEach((btn) => {
      btn.addEventListener('click', () => {
        applyBaseFilter(btn.dataset.kbpFilter);
      });
    });

    globalDoorSelect?.addEventListener('change', () => {
      updateSelectedFinishBox();
      updateCardsForGlobalFinish();
    });

    globalBodySelect?.addEventListener('change', () => {
      updateSelectedFinishBox();
      updateCardsForGlobalFinish();
    });

    baseWidthInput?.addEventListener('input', () => {
      const current = parseFloat(totalBaseWidthEl?.textContent || 0) || 0;
      updateFitStatus('base', current);
    });

    wallWidthInput?.addEventListener('input', () => {
      const current = parseFloat(totalWallWidthEl?.textContent || 0) || 0;
      updateFitStatus('wall', current);
    });

    tallWidthInput?.addEventListener('input', () => {
      const current = parseFloat(totalTallWidthEl?.textContent || 0) || 0;
      updateFitStatus('tall', current);
    });

    planner.querySelectorAll('.kbp-card').forEach((card) => {
      const variantsJson = card.querySelector('.kbp-card__variants');
      const variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
      const addBtn = card.querySelector('[data-kbp-add]');

      addBtn?.addEventListener('click', () => {
        const door = getSelectedDoor();
        const body = getSelectedBody();

        if (!door || !body) {
          alert('Please select door color and body color first.');
          return;
        }

        const variant = findVariant(variants, door, body);

        if (!variant) {
          alert('This finish combination is not available for this item.');
          return;
        }

        if (!variant.available) {
          alert('This variant is currently unavailable.');
          return;
        }

        planItems.push({
          productId: card.dataset.productId,
          title: card.dataset.productTitle,
          width: parseFloat((card.dataset.productWidth || '0').replace(/[^\d.]/g, '')) || 0,
          variantId: variant.id,
          price: Number(variant.price || 0),
          doorColor: door,
          bodyColor: body,
          runType: card.dataset.runType || card.dataset.parentTab || 'base'
        });

        renderPlan();
      });
    });

    clearBtn?.addEventListener('click', () => {
      planItems = [];
      renderPlan();
    });

    addAllBtn?.addEventListener('click', async () => {
      if (!planItems.length) return;

      const grouped = new Map();
      planItems.forEach((item) => {
        const key = String(item.variantId);
        if (!grouped.has(key)) {
          grouped.set(key, { id: item.variantId, quantity: 1 });
        } else {
          grouped.get(key).quantity += 1;
        }
      });

      const items = Array.from(grouped.values());

      addAllBtn.disabled = true;
      addAllBtn.textContent = 'Adding...';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items })
        });

        if (!response.ok) {
          throw new Error('Cart request failed');
        }

        window.location.href = '/cart';
      } catch (error) {
        console.error(error);
        alert('There was an error adding the selected items to the cart.');
        addAllBtn.disabled = false;
        addAllBtn.textContent = 'Add All to Cart';
      }
    });

    applyBaseFilter('all');
    updateSelectedFinishBox();
    updateCardsForGlobalFinish();
    renderPlan();
  });
});